import { HOME_SHUTTLE_APPROACHING_MAX_MINUTES } from './homeTimePolicy'

export const SHUTTLE_VISUAL_PHASES = Object.freeze({
  IDLE: 'idle',
  APPROACHING: 'approaching',
  DEPARTING: 'departing',
  TRANSITIONING: 'transitioning',
  ENDED: 'ended',
})

const PHASE_LABELS = Object.freeze({
  idle: '대기',
  approaching: '곧 출발',
  departing: '출발',
  transitioning: '다음 운행',
  ended: '운행 종료',
})

export function getShuttleRouteMotionPhase({
  minsUntilDeparture,
  departureTime = null,
  isEnded = false,
  approachingWithinMinutes = HOME_SHUTTLE_APPROACHING_MAX_MINUTES,
} = {}) {
  if (isEnded || !departureTime || minsUntilDeparture == null) {
    return SHUTTLE_VISUAL_PHASES.ENDED
  }
  if (minsUntilDeparture <= 0) return SHUTTLE_VISUAL_PHASES.DEPARTING
  if (minsUntilDeparture <= approachingWithinMinutes) return SHUTTLE_VISUAL_PHASES.APPROACHING
  return SHUTTLE_VISUAL_PHASES.IDLE
}

export function getShuttleRouteMotionMode({ departureTime = null, followingDepartureTime = null } = {}) {
  if (!departureTime || !followingDepartureTime) return 'single'
  const toMinutes = value => {
    const [hours, minutes] = String(value).split(':').map(Number)
    return Number.isFinite(hours) && Number.isFinite(minutes) ? hours * 60 + minutes : null
  }
  const current = toMinutes(departureTime)
  const following = toMinutes(followingDepartureTime)
  if (current == null || following == null) return 'single'
  const gap = following - current
  return gap > 0 && gap <= 15 ? 'cluster' : 'single'
}

export function getShuttleRouteMotionLabel(phase) {
  return PHASE_LABELS[phase] ?? PHASE_LABELS.ended
}
